export function FolderIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="42"
      height="32"
      viewBox="0 0 42 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M1.22392e-06 4C1.22392e-06 1.79086 1.79086 0 4 0H11.3733C12.2911 0 13.1725 0.358887 13.8293 1C14.486 1.64111 15.3674 2 16.2852 2H38C40.2091 2 42 3.79086 42 6V28C42 30.2091 40.2091 32 38 32H4C1.79086 32 1.22392e-06 30.2091 1.22392e-06 28V4Z"
        fill="#60A5FA"
      />
      <path
        d="M1.22392e-06 28V4C1.22392e-06 1.79086 1.79086 0 4 0H11.3733C12.2336 0 13.0618 0.315337 13.7031 0.882812L13.9551 1.11719C14.5964 1.68475 15.4249 1.99998 16.2852 2H38C40.2091 2 42 3.79086 42 6V28C42 30.2091 40.2091 32 38 32V31C39.6569 31 41 29.6569 41 28V6C41 4.34315 39.6569 3 38 3H16.2852C15.1064 2.99998 13.9744 2.53915 13.1309 1.71582C12.6609 1.25706 12.0298 1 11.373 1H4C2.34315 1 1 2.34315 1 4V28C1 29.6569 2.34315 31 4 31L4 32L3.79395 31.9951C1.68056 31.8879 1.22392e-06 30.14 1.22392e-06 28ZM38 31V32H4L4 31H38Z"
        fill="#60A5FA"
      />
      <path
        d="M0 10C0 7.79086 1.79086 6 4 6H38C40.2091 6 42 7.79086 42 10V28C42 30.2091 40.2091 32 38 32H4C1.79086 32 1.22392e-06 30.2091 1.22392e-06 28L0 10Z"
        fill="#93C5FD"
      />
      <path
        d="M38 31V32H4L4 31H38ZM41 28V10C41 8.34315 39.6569 7 38 7H4C2.34315 7 1 8.34315 1 10L1 28C1 29.6569 2.34315 31 4 31L4 32L3.79395 31.9951C1.68056 31.8879 1.22392e-06 30.14 1.22392e-06 28L0 10C0 7.79086 1.79086 6 4 6H38C40.2091 6 42 7.79086 42 10V28C42 30.2091 40.2091 32 38 32V31C39.6569 31 41 29.6569 41 28Z"
        fill="#60A5FA"
      />
    </svg>
  )
}
